import { UseQueryOptions } from 'react-query';
import { useCustomQuery } from '../../../../../hooks/query';
import { AmendmentTransactionInfo, CandidateDetails, ReviewSubjectsResponse } from '../../model';
import {
  getAmendmentCandidateProfile,
  getAmendmentReviewSubject,
  getAmendmentTransactionInfo,
} from '../api-services/api';
import {
  GET_AMENDMENT_CANDIDATE_PROFILE,
  GET_AMENDMENT_REVIEW_SUBJECT,
  GET_AMENDMENT_TRANSACTION_INFO,
} from './keys';
import { ServiceError } from '../../../../../hooks/error';

export const useGetAmendmentReviewSubject = (uuid: string) =>
  useCustomQuery<ReviewSubjectsResponse>(
    GET_AMENDMENT_REVIEW_SUBJECT,
    () => getAmendmentReviewSubject(uuid).then((res) => res.data),
    {},
    false,
    false
  );

export const useGetAmendmentCandidateProfile = (
  uuid: string,
  queryOptions?: UseQueryOptions<CandidateDetails, ServiceError> | undefined
) =>
  useCustomQuery<CandidateDetails>(
    [GET_AMENDMENT_CANDIDATE_PROFILE, uuid],
    () => getAmendmentCandidateProfile(uuid).then((res) => res.data),
    queryOptions,
    false,
    false
  );

export const useGetAmendmentTransactionInfo = (uuid = '') =>
  useCustomQuery<AmendmentTransactionInfo>(GET_AMENDMENT_TRANSACTION_INFO, () =>
    getAmendmentTransactionInfo(uuid).then((response) => response.data)
  );
